<template>
    <v-container fluid ma-3 pa-3>
        <v-layout row wrap justify-center>
            <v-flex>
                <span class="style_title">User Management</span>
                <br>
                <br>
                <div>
                    <span class="style_description" style="white-space: pre-line">In the “User Management” section, an admin can manage all the users who have access to the private space of Discovery.
The page shows a table with the list of users with a text search bar for a quick search.
The user fields are:
                        <ul>
                            <li>Username</li>
                            <li>First name</li>
                            <li>Last name</li>
                            <li>Email</li>
                            <li>Role</li>
                            <li>Group</li>
                            <li>Creation date</li>
                        </ul>

                        <br>
                        <v-img
                                max-width="800"
                                :src="require('@/assets/img/help/users.png')"
                        >
                </v-img>
                    </span>
                    <br>

<span class="style_paragraph" style="white-space: pre-line">How to create a new user</span>
                    <br>

                    <span class="style_description" style="white-space: pre-line">An admin can create a new user, by clicking on the blue button “NEW USER”.
When filling in the fields, remember that:
                        <ul>
                            <li>Username is unique for each user, so there can be no users with the same username. It must be between 3 and 32 characters long</li>
                            <li>Password must be at least 8 characters long</li>
                            <li>Role identifies which functionalities the user will be able to access:
                            <ul>
                                <li>Admin can access to:
                                <ul>
                                    <li>Chat</li>
                                    <li>History chat</li>
                                    <li>Group management</li>
                                    <li>User Management</li>
                                    <li>Startup Management</li>
                                    <li>Startup Search</li>
                                    <li>Challenge Management</li>
                                    <li>Synonyms</li>
                                </ul>
                                </li>
                                <li>User can access:
                                <ul>
                                    <li>Chat</li>
                                </ul></li>
                                <li>Customer can access:
                                <ul>
                                    <li>Challenge Management</li>
                                </ul></li>
                                <li>Customer + chat can access:
                                <ul>
                                    <li>Chat</li>
                                    <li>Challenge Management</li>
                                </ul>
                                </li>
                            </ul>
                            </li>
                            <li>the group identifies which challenges the user will have visibility of (excluding user type)</li>
                        </ul>
Press the green "Submit" button to create the user: he/she will automatically receive an email with the credentials you just created.
    </span>
                    <br>

<span class="style_paragraph" style="white-space: pre-line">How to modify an existing user</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">To edit a user simply click on the pencil icon on the corresponding line.
You can modify the fields according to the rules described in the previous paragraph and confirm by pressing the green "Submit" button.
    </span>
                    <br>

<span class="style_paragraph" style="white-space: pre-line">How to reset an existing user’s password</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">To change a user password simply click on the key icon on the corresponding line. The new password must be repeated twice and must respect the rule of at least 8 characters.
To confirm, press the green "Submit" button: an email will automatically be sent to the user with the new password.
    </span>
                    <br>

<span class="style_paragraph" style="white-space: pre-line">How to remove a user</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">To remove a user simply click on the bin icon on the corresponding line and confirm your choice.


</span>
                </div>
                <br>


            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    export default {
        name: "UserManagementHelp",
        components: {},
        data() {
            return {

            }
        },

        methods: {

        }
    }
</script>

<style scoped>
    .style_description{
        font-size: 18px;
    }

    .style_paragraph{
        font-size: 22px;
        font-weight: bold;
    }

    .style_title{
        font-size: 34px;
        font-weight: bold;
    }

</style>